import { createContext } from "react";

import type {
  AppMusicTrackId,
  AppSfxTrackId,
  AppVoiceTrackId
} from "../../audio/app-catalog";
import type { AudioChannel } from "../../audio/catalog";
import type { AudioPreferences } from "../../audio/preferences";
import type {
  AudioPlaybackResult,
  AudioRuntimeSnapshot,
  AudioUnlockResult
} from "../../audio/runtime";

export interface AudioCommands {
  unlock(): Promise<AudioUnlockResult>;
  playMusic(trackId: AppMusicTrackId): Promise<AudioPlaybackResult>;
  playVoice(trackId: AppVoiceTrackId): Promise<AudioPlaybackResult>;
  replayVoice(): Promise<AudioPlaybackResult>;
  playSfx(trackId: AppSfxTrackId): Promise<AudioPlaybackResult>;
  stopMusic(): void;
  stopVoice(playbackId?: number): void;
  stopAll(): void;
  setMuted(muted: boolean): AudioPreferences;
  toggleMuted(): AudioPreferences;
  setMasterVolume(volume: number): AudioPreferences;
  setChannelVolume(channel: AudioChannel, volume: number): AudioPreferences;
}

export interface AudioContextValue {
  readonly snapshot: AudioRuntimeSnapshot;
  readonly preferences: AudioPreferences;
  readonly commands: AudioCommands;
}

export const AudioContext = createContext<AudioContextValue | null>(null);
